@if (!useOkta) {
  <div class="container verify-account">
    <div class="row justify-content-md-center">
      <mdb-card class="col-md-8">
        <mdb-card-body>
          <app-my-account-verify-account-error-messages></app-my-account-verify-account-error-messages>
          <div>
            @switch (view) {
              @case ('2') {
                <div>
                  <mdb-card-title class="text-center">
                    <div aria-level="1" tabindex="0" class="pt-3 pb-3 account-header" aria-live="assertive">
                    {{ 'MY_ACCOUNT_LOGIN.THANKS' | translate }}</div>
                  </mdb-card-title>
                </div>
                <mdb-card-text>
                  <app-my-account-verify-code (resetEmitter)="resetEmitterFunction($event)"
                    (viewEmitter)="viewEmitterFunction($event)" [verifyType]="verifyType"
                  [verifyCodeRequest]="verifyCodeRequest"></app-my-account-verify-code>
                </mdb-card-text>
              }
              @default {
                <div>
                  <mdb-card-title class="text-center">
                    <div aria-level="1" tabindex="0" class="pt-3 pb-3 account-header" aria-live="assertive">
                    {{ 'MY_ACCOUNT_LOGIN.LOGIN_METHOD' | translate }}</div>
                  </mdb-card-title>
                </div>
                <mdb-card-text>
                  <div class="text-center">
                    @if ((verifyAccount$ | async) === 'invalid') {
                      <div
                        class="alert alert-warning w-100 text-center" role="alert">
                        {{ 'MY_ACCOUNT_LOGIN.ERROR_INFO' | translate }}
                      </div>
                    }
                    <p tabindex="0"> {{ 'MY_ACCOUNT_LOGIN.VERIFY_ACCOUNT' | translate }}</p>
                    <mdb-tabset #staticTabs [buttonClass]="'nav md-pills mt-4'" [justified]="true"
                      [contentClass]="'card'">
                      <mdb-tab heading="{{ 'MY_ACCOUNT_LOGIN.EMAIL' | translate }}">
                        <app-my-account-verify-email (viewEmitter)="viewEmitterFunction($event)"
                          (verifyType)="verifyTypeEmitterFunction($event)"
                          (verifyCodeRequest)="verifyCodeReuqestEmitterFunction($event)"
                        [reset]="emailReset"></app-my-account-verify-email>
                      </mdb-tab>
                      <mdb-tab heading="{{ 'MY_ACCOUNT_LOGIN.TEXT' | translate }}">
                        <app-my-account-verify-phone (viewEmitter)="viewEmitterFunction($event)"
                          (verifyType)="verifyTypeEmitterFunction($event)"
                          (verifyCodeRequest)="verifyCodeReuqestEmitterFunction($event)"
                        [reset]="phoneReset"></app-my-account-verify-phone>
                      </mdb-tab>
                    </mdb-tabset>
                    <div class="w-100 text-center pt-3">
                      <div class="w-100 text-center pt-4">
                        <span tabindex="0">{{ 'MY_ACCOUNT_LOGIN.HELP' | translate }}<br />{{
                        'MY_ACCOUNT_LOGIN.CALL' | translate:{ phone:branding.cs_phone_number } }}</span>
                      </div>
                    </div>
                  </div>
                </mdb-card-text>
              }
            }
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
}

@if (useOkta) {
  <div class="container" [ngClass]="{hide:showOktaPasswordFlow}">
    <app-inline-loader></app-inline-loader>
    <div class="row justify-content-center">
      <div class="pl-4 pr-4">
        <div id="widget-container" #widgetContainer>
          @if (showSpinner) {
            <div class="okta-spinner">
              <div class="preloader-wrapper active indicator">
                <div class="spinner-layer spinner-client-color">
                  <div class="circle-clipper left">
                    <div class="circle"></div>
                  </div>
                  <div class="gap-patch">
                    <div class="circle"></div>
                  </div>
                  <div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (useOkta) {
  <div class="container" [ngClass]="{hide:!showOktaPasswordFlow}">
    <app-inline-loader></app-inline-loader>
    @if (passwordFlow == 1) {
      <div class="row justify-content-center">
        <div class="pl-4 pr-4">
          <div id="password-reset-container">
            <div>
              <h2 class="okta-form-title">Password Reset</h2>
            </div>
            @if (orderNumberError) {
              <div class="okta-form-infobox-error infobox infobox-error" role="alert">
                <span class="icon error-16"></span>
                <p>There was an error retrieving your account.</p>
              </div>
            }
            <div class="disclaimer o-form-fieldset-container">
              Your order number is needed to verify account.
            </div>
            <form [formGroup]="orderNumberForm">
              <div class="o-form-fieldset-container">
                <div class="o-form-fieldset o-form-label-top">
                  <div class="okta-form-label o-form-label">
                    <label>Order Number</label>
                  </div>
                  <div class="o-form-input">
                    <span class="o-form-control okta-form-input-field input-fix">
                      <input type="text" id="orderNumberInput" formControlName="orderNumber" autocomplete="off" maxlength="150">
                    </span>
                  </div>
                  @if (orderNumberForm.controls.orderNumber.invalid && (orderNumberForm.controls.orderNumber.dirty || orderNumberForm.controls.orderNumber.touched)) {
                    <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert"
                      >
                      @if (orderNumberForm.controls.orderNumber.errors.required) {
                        <span>This field cannot be
                        left blank</span>
                      }
                    </mdb-error>
                  }
                </div>
                <div class="o-form-fieldset o-form-label-top">
                  <div class="okta-form-label o-form-label">
                    <label>Last Name</label>
                  </div>
                  <div class="o-form-input">
                    <span class="o-form-control okta-form-input-field input-fix">
                      <input id="lastNameInput" formControlName="lastName" autocomplete="off" maxlength="150">
                    </span>
                  </div>
                  @if (orderNumberForm.controls.lastName.invalid && (orderNumberForm.controls.lastName.dirty || orderNumberForm.controls.lastName.touched)) {
                    <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert"
                      >
                      @if (orderNumberForm.controls.lastName.errors.required) {
                        <span>This field cannot be
                        left blank</span>
                      }
                    </mdb-error>
                  }
                </div>
                <div class="o-form-button-bar">
                  <input id="submitOrderNumberButton" class="button button-primary" type="submit" value="Submit"
                    (click)="checkOrderNummber(orderNumberForm)">
                </div>
              </div>
            </form>
                <a id="backToSignInLinkPassword" class="link" (click)="showWidget()">Back to Sign In</a>
          </div>
        </div>
      </div>
    }
    @if (passwordFlow == 2 || passwordFlow === 3) {
      <div class="row justify-content-center">
        <app-inline-loader></app-inline-loader>
        <div class="pl-4 pr-4">
          <div id="password-reset-container">
            <div>
              @if (passwordFlow == 2) {
                <h2 class="okta-form-title">Update Password</h2>
              }
              @if (passwordFlow == 3) {
                <h2 class="okta-form-title">Create Password</h2>
              }
            </div>
            <div class="disclaimer o-form-fieldset-container">
              @if (oktaPasswordErrorReason) {
                <span class="color-error">{{oktaPasswordErrorReason}}</span>
              }
              <br>
                Your password must be at least twelve (12) characters long and connot contain any part of the
                username.
                <br>
                  <br>
                    It should include one of each below:<br>
                    Uppercase: A-Z; Lowercase: a-z; Number: 0-9; Symbol: !&#64;#$%^&*()?
                  </div>
                  <form [formGroup]="changePasswordForm">
                    <div class="o-form-fieldset-container">
                      <!-- <div class="o-form-fieldset o-form-label-top">
                      <div class="okta-form-label o-form-label">
                        <label>Current Password</label>
                      </div>
                      <div class="o-form-input">
                        <span class="o-form-control okta-form-input-field input-fix">
                          <input type="password" placeholder="" name="" value="" aria-label=""
                            formControlName="oldPassword" autocomplete="off" class="password-with-toggle" minlength="12" maxlength="150">
                        </span>
                      </div>
                      <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert"
                        *ngIf="changePasswordForm.controls.oldPassword.invalid && (changePasswordForm.controls.oldPassword.dirty || changePasswordForm.controls.oldPassword.touched)">
                        <span *ngIf="changePasswordForm.controls.oldPassword.errors.required">This field cannot be left blank</span>
                      </mdb-error>
                    </div> -->
                    <div class="o-form-fieldset o-form-label-top">
                      <div class="okta-form-label o-form-label">
                        <label>New Password</label>
                      </div>
                      <div class="o-form-input">
                        <span class="o-form-control okta-form-input-field input-fix">
                          <input id="newPasswordInputOkta" type="password" placeholder="" name="" value="" aria-label=""
                            formControlName="newPassword" autocomplete="off" class="password-with-toggle"
                            minlength="12" maxlength="150" (focus)="clearPasswordError()">
                        </span>
                      </div>
                      @if (oktaPasswordErrorReason) {
                        <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
                          <span>{{oktaPasswordErrorReason}}</span>
                        </mdb-error>
                      }
                      @if (!oktaPasswordErrorReason && changePasswordForm.controls.newPassword.invalid && (changePasswordForm.controls.newPassword.dirty || changePasswordForm.controls.newPassword.touched)) {
                        <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
                          @if (changePasswordForm.controls.newPassword.errors?.required) {
                            <span>This field cannot
                            be left blank. &nbsp;</span>
                          }
                          @if (changePasswordForm.controls.newPassword.errors?.minlength) {
                            <span>Password is too
                            short. &nbsp;</span>
                          }
                          @if (changePasswordForm.controls.newPassword.errors?.pattern) {
                            <span>Password is too
                            weak. &nbsp;</span>
                          }
                          @if (changePasswordForm.controls.newPassword.errors?.username) {
                            <span>Password contains
                            username.</span>
                          }
                        </mdb-error>
                      }
                    </div>
                    <div class="o-form-fieldset o-form-label-top">
                      <div class="okta-form-label o-form-label">
                        <label>Confirm New Password</label>
                      </div>
                      <div class="o-form-input">
                        <span class=" o-form-control okta-form-input-field input-fix">
                          <input id="confirmNewPasswordInputOkta" type="password" placeholder="" name="" value="" aria-label=""
                            formControlName="confirmNewPassword" autocomplete="off"
                            class="password-with-toggle" minlength="12" maxlength="150">
                        </span>
                      </div>
                      @if (changePasswordForm.controls.confirmNewPassword.invalid && (changePasswordForm.controls.confirmNewPassword.dirty || changePasswordForm.controls.confirmNewPassword.touched)) {
                        <mdb-error class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
                          @if (changePasswordForm.controls.confirmNewPassword.errors?.mismatch) {
                            <span>Please
                            make sure passwords match</span>
                          }
                          @if (changePasswordForm.controls.confirmNewPassword.errors?.required) {
                            <span>This field
                            cannot be left blank</span>
                          }
                        </mdb-error>
                      }
                    </div>
                    <div class="o-form-button-bar">
                      @if (passwordFlow == 2) {
                        <button mdbBtn id="updatePasswordButton" class="button button-primary"
                          [disabled]="!changePasswordForm.valid" type="button"
                          (click)="setPassword($event)">Update</button>
                      }
                      @if (passwordFlow == 3) {
                        <button mdbBtn id="submitPasswordButton" class="button button-primary"
                          [disabled]="!changePasswordForm.valid" type="button"
                          (click)="setPassword($event)">Submit</button>
                      }
                    </div>
                  </div>
                </form>
                <a id="backToSignInLink" class="link" (click)="showWidget()">Back to Sign In</a>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <!-- Start of Selection -->
    @if (useOkta && branding.okta_faq) {
      <div class="container">
        <section class="faq-overview">
          <div class="content-block faq">
            <div class="main-expansion-panel">
              <h3 class="text-center pb-2 pt-4 underline">Okta Help Questions</h3>
              <div class="row justify-content-center">
                <div class="col-12 col-md-5">
                  <mat-accordion multi="true">
                    @for (faq of branding.okta_faq; track faq) {
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <span>{{faq.question}}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="answer">{{faq.answer}}</p>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
